module.exports = __webpack_public_path__ + "img/7.55ff3b5e.png";